<template>
  <div class="grid grid--gap-xs-0 my-0">
    <div class="form-field">
      <div class="form-group">
        <!-- <input-field :tooltip="
          modelValue.nombre_item !== ''
            ? modelValue.nombre_item
            : 'Seleccione...'
        " tooltip-position="bottom" readonly v-model="modelValue.nombre_item" id="item"
          placeholder="Producto o servicio">
          <span>Ítem</span>
          <span v-if="errores.id_item" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.id_item[0] }}</strong>
          </span>
        </input-field> -->
        <div class="select2-field">
          <v-select placeholder="Seleccione un item..." id="item" v-model="selectedItem" @search="onSearchItems"
            :options="items" label="descripcion_item" @input="inputItem"></v-select>
          <label for="item">Item</label>
          <span v-if="errores.id_item" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.id_item[0] }}</strong>
          </span>
        </div>
        <button :editable="editable" @click="buscarItems" class="btn-info" type="button">
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>
    <div class="grid grid--auto-flow-sm-column grid--gap-sm-3 grid--gap-xs-0 mb-0">
      <div class="form-field">
        <div class="form-group">
          <div class="form-field">
            <input-field @input="cambiarTotal" :readonly="!precioEditable && !editable" vMoney :format="moneyPersonalizado"
              placeholder="$ #,###.##" id="precio" v-model="modelValue.precio">
              <span>Precio</span>
              <span v-if="errores.precio" class="helper-text text-danger" slot="helper">
                <strong>{{ errores.precio[0] }}</strong>
              </span>
            </input-field>
          </div>
          <button v-show="modelValue.id_item != null && modelValue.id_item != ''" @click="verPrecios" type="button"
            class="btn-info btn--text-outline">
            <i class="fa fa-table"></i>
          </button>
        </div>
      </div>
      <div class="form-field">
        <div class="form-group">
          <div class="form-field">
            <input-field @input="cambiarTotal" :readonly="!editable" vMoney :format="decimalPersonalizado" placeholder="#,###.##" id="cantidad"
              v-model="modelValue.cantidad">
              <span>Cantidad</span>
              <span v-if="errores.cantidad" class="helper-text text-danger" slot="helper">
                <strong>{{ errores.cantidad[0] }}</strong>
              </span>
            </input-field>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid--auto-flow-sm-column grid--gap-sm-3 grid--gap-xs-0 mb-0">
      <div class="form-field">
        <input-field vMoney :format="porcentaje" placeholder="###.## %" id="porcentaje_iva" readonly
          v-model="modelValue.porcentaje_iva">
          <span>% IVA</span>
        </input-field>
      </div>
      <div class="form-field">
        <input-field vMoney :format="money" readonly placeholder="$ #,###.##" id="iva" :value="iva">
          <span>IVA</span>
        </input-field>
      </div>
    </div>
    <div class="grid grid--auto-flow-sm-column grid--gap-sm-3 grid--gap-xs-0 mb-0">
      <div class="form-field">
        <input-field :readonly="!editable" @keyup.native="calcularDescuentoTotal" vMoney :format="porcentaje"
          placeholder="% ###.##" id="porcentaje_descuento" v-model="modelValue.porcentaje_descuento">
          <span>% Descuento</span>
        </input-field>
      </div>
      <div class="form-field">
        <input-field :readonly="!editable" @keyup.native="calcularPorcentajeDescuento" vMoney :format="money"
          placeholder="$ #,###.##" id="total_descuento" v-model="modelValue.total_descuento">
          <span>Total de descuento</span>
        </input-field>
      </div>
    </div>
    <div class="form-inline">
      <label>
        <input type="checkbox" disabled v-model="modelValue.irbpnr" />
        <span>IRBPNR</span>
      </label>
    </div>
    <div class="grid grid--auto-flow-sm-column mb-0">
      <div class="form-field">
        <input-field vMoney :format="money" readonly placeholder="$ #,###.##" id="ice" :value="ice">
          <span>ICE</span>
        </input-field>
      </div>
      <div class="form-field">
        <input-field readonly vMoney :format="money" placeholder="$ #,###.##" id="totalIrbpnr" :value="irbpnr">
          <span>Total IRBPNR</span>
        </input-field>
      </div>
    </div>
    <!-- <div class="form-field">
      <input-field readonly vMoney :format="money" placeholder="$ #,###.##" id="total" :value="total">
        <span>Total</span>
        <span v-if="errores.total" class="helper-text text-danger" slot="helper">
          <strong>{{ errores.total[0] }}</strong>
        </span>
      </input-field>
    </div> -->
    <div class="form-field">
      <input-field :readonly="!editable" @keyup.native="inputTotalDigitado" vMoney :format="money" placeholder="$ #,###.##" id="total" v-model="totalDigitado">
        <span>Total</span>
        <span v-if="errores.total" class="helper-text text-danger" slot="helper">
          <strong>{{ errores.total[0] }}</strong>
        </span>
      </input-field>
    </div>
    <div class="form-inline">
      <label for="mostrarDetalle">
        <input :readonly="!editable" type="checkbox" id="mostrarDetalle"
          v-model="modelValue.mostrar_detalle" /><span>Mostrar detalle</span>
      </label>
    </div>
    <div class="form-field">
      <textarea-field :readonly="!editable" v-model="modelValue.detalle" placeholder="Agregue una nota" id="detalle">
        <span>Detalle</span>
      </textarea-field>
    </div>
    <div class="dynamic-table__buttons">
      <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button">
        <i class="fa fa-ban"></i><span>Cancelar</span>
      </button>
      <button :disabled="!editable" @click="aceptarItem" class="btn-success" type="button">
        <i class="fa fa-check"></i><span>Aceptar</span>
      </button>
    </div>
    <modal height="auto" width="70%" scrollable name="items">
      <lista-item :tipo="tipo" :searchButton="false" @selected="seleccionarItem" :filterStatus="false"
        :createButton="true"></lista-item>
    </modal>
    <modal name="precios" width="50%" height="auto" resizable reset adaptive scrollable>
      <lista-precios @cerrar="$modal.hide('precios')" @seleccionar="selectedPrecio" :itemId="modelValue.id_item">
      </lista-precios>
    </modal>
  </div>
</template>

<script>
import ListaPrecios from "../mantenimiento/items/ListaPrecios";

export default {
  components: {
    ListaPrecios,
  },
  props: {
    factura_exterior: {
      type: Boolean,
      required: false,
      default: false
    },
    iva_incluido_exp: {
      type: Boolean,
      required: false,
      default: false
    },
    decimales_compras: {
      required: false,
      default: 2,
    },
    moneyPersonalizado: {
      type: Object,
      required: true,
    },
    decimalPersonalizado: {
      type: Object,
      required: true,
    },
    precioEditable: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Object,
      default: function () {
        return {
          margen_utilidad: 0,
          tipo_item: "",
          id_item: "",
          cantidad: 1,
          precio: 0,
          precio_produccion: 0,
          total_descuento: 0,
          iva: 0,
          ice: 0,
          porcentaje_descuento: 0,
          total: 0,
          nombre_item: "",
          porcentaje_iva: 0,
          porcentaje_ice: 0,
          id_iva: "",
          id_ice: "",
          irbpnr: false,
          total_irbpnr: 0,
          detalle: "",
          total_parcial: 0,
          total_impuestos: 0,
          total_inicial: 0,
          tarifa_especifica_ice: 0,
          numero_unidades_ice: 0,
          total_parcial_ice: 0,
          porcentaje_ed_valorem: 0,
          cantidad_ice: 0,
          cantidad_irbpnr: 0,
          precio_sin_subsidio: 0,
          valor_subsidio: 0,
          mostrar_detalle: true,
        };
      },
    },
    valorIrbpnr: {
      type: Number,
      required: true,
    },
    tipoComprobante: {
      type: String,
      required: true,
    },
    tipo: {
      type: String,
      required: false,
      default: "E",
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: function () {
    return {
      totalDigitado: 0,
      items: [],
      selectedItem: null,
      modelValue: this.value,
      money: money,
      money2: money2,
      porcentaje: porcentaje,
      decimal: decimal,
      errores: {
        id_item: undefined,
        cantidad: undefined,
        precio: undefined,
      },
    };
  },
  computed: {
    iva: function () {
      let totalParcial = this.total_parcial;
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * totalParcial;
      iva = round(iva);
      this.modelValue.iva = iva;
      return iva;
    },
    total: function () {
      let total =
        parseFloat(this.total_parcial) +
        parseFloat(this.iva) +
        parseFloat(this.ice) +
        parseFloat(this.irbpnr);
      total = round(total);
      this.modelValue.total = total;
      return total;
    },
    total_parcial_ice: function () {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precioVenta = parseFloat(this.modelValue.precio);
      if (isNaN(precioVenta)) precioVenta = 0;
      if (
        this.modelValue.porcentaje_ed_valorem !== null &&
        this.modelValue.precio_produccion !== null
      ) {
        let precioProduccion =
          cantidad * parseFloat(this.modelValue.precio_produccion);
        if (precioProduccion > precioVenta) {
          precioProduccion = round(precioProduccion);
          this.modelValue.total_parcial_ice = precioProduccion;
          return precioProduccion;
        }
      }
      let porcentajeIva = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentajeIva)) porcentajeIva = 0;
      let iva = (porcentajeIva / 100) * precioVenta;
      precioVenta += iva;
      precioVenta = round(precioVenta);
      this.modelValue.total_parcial_ice = precioVenta;
      return precioVenta;
    },
    ice: function () {
      let totalConIva = this.total_parcial_ice;
      let ice = 0;
      if (this.modelValue.porcentaje_ice !== null)
        ice = totalConIva * (parseFloat(this.modelValue.porcentaje_ice) / 100);
      else if (this.modelValue.porcentaje_ed_valorem !== null)
        ice =
          totalConIva *
          (parseFloat(this.modelValue.porcentaje_ed_valorem) / 100);
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      if (this.modelValue.tarifa_especifica_ice !== null) {
        if (this.modelValue.numero_unidades_ice === null)
          ice +=
            parseFloat(this.modelValue.cantidad) *
            parseFloat(this.modelValue.tarifa_especifica_ice);
        else
          ice +=
            parseInt(
              (parseFloat(this.modelValue.cantidad_ice) *
                parseFloat(this.modelValue.cantidad)) /
              this.modelValue.numero_unidades_ice
            ) * parseFloat(this.modelValue.tarifa_especifica_ice);
      }
      if (isNaN(ice)) ice = 0;
      ice = round(ice);
      this.modelValue.ice = ice;
      return ice;
    },
    irbpnr: function () {
      if (this.modelValue.irbpnr) {
        let cantidad =
          parseFloat(this.modelValue.cantidad) *
          parseFloat(this.modelValue.cantidad_irbpnr);
        if (isNaN(cantidad)) cantidad = 0;
        let irbpnr = cantidad * this.valorIrbpnr;
        irbpnr = round(irbpnr);
        this.modelValue.total_irbpnr = irbpnr;
        return irbpnr;
      } else return 0;
    },
    total_inicial: function () {
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let precio = parseFloat(this.modelValue.precio);
      if (isNaN(precio)) precio = 0;
      let totalInicial = cantidad * precio;
      totalInicial = round(totalInicial);
      this.modelValue.total_inicial = totalInicial;
      return totalInicial;
    },
    total_parcial: function () {
      let totalInicial = this.total_inicial;
      let totalDescuento = parseFloat(this.modelValue.total_descuento);
      if (isNaN(totalDescuento)) totalDescuento = 0;
      let totalParcial = totalInicial - totalDescuento;
      totalParcial = round(totalParcial);
      this.modelValue.total_parcial = totalParcial;
      return totalParcial;
    },
  },
  methods: {
    cambiarTotal: function () {
      this.totalDigitado = this.total;
    },
    inputTotalDigitado: function () {
      let total = parseFloat(this.totalDigitado);
      this.modelValue.total_descuento = 0;
      let cantidad = parseFloat(this.modelValue.cantidad);
      if (isNaN(cantidad))
        cantidad = 0;
      if (isNaN(total))
        total = 0;
      let porcentaje = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentaje)) porcentaje = 0;
      let precioItem = total / cantidad;
      // if (porcentaje > 0 && this.modelValue.iva_incluido_precio) {
      if (porcentaje > 0 && !this.factura_exterior) {
        if (isNaN(precioItem)) precioItem = 0;
        this.modelValue.precio = precioItem / (1 + porcentaje / 100);
      } else {
        this.modelValue.precio = precioItem;
      }
      this.modelValue.total = this.totalDigitado;
    },
    inputItem: function () {
      if (this.selectedItem != null) {
        axios.get(url + '/items/' + this.selectedItem.sys_id).then(({ data }) => {
          let item = data;
          this.seleccionarItem(item);
        }).catch(() => {
          swal('Hubo un error, intente nuevamente.', 'Error', 'error');
        });
      }
    },
    onSearchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.items = json;
          loading(false);
        } else loading(false);
      };
      let urlApi = `${url}/items-search?search=${search}`;
      xmlhttp.open("GET", urlApi, true);
      xmlhttp.send();
    },
    selectedPrecio: function (precio) {
      let porcentaje = parseFloat(this.modelValue.porcentaje_iva);
      if (isNaN(porcentaje)) porcentaje = 0;
      // if (porcentaje > 0 && this.modelValue.iva_incluido_precio) {
      if (porcentaje > 0 && (this.modelValue.iva_incluido_precio || (this.modelValue.iva_incluido_precio && !this.iva_incluido_exp && this.factura_exterior))) {
        let precioItem = parseFloat(precio.precio);
        if (isNaN(precioItem)) precioItem = 0;
        this.modelValue.precio = round(precioItem / (1 + porcentaje / 100));
      } else {
        this.modelValue.precio = precio.precio;
      }
      //this.modelValue.precio = precio.precio;
      this.$modal.hide("precios");
    },
    verPrecios: function () {
      this.$modal.show("precios");
    },
    aceptarItem: function () {
      this.errores = {};
      let errores = false;
      if (
        this.modelValue.cantidad === "" ||
        parseFloat(this.modelValue.cantidad) < 1
      ) {
        this.errores.cantidad = [
          "La cantidad es requerida y debe ser mayor o igual a 1.",
        ];
        errores = true;
      }
      if (this.modelValue.precio === "") {
        this.errores.cantidad = ["El precio es requerido."];
        errores = true;
      }
      if (this.modelValue.total === "") {
        this.errores.total = ["El total es requerido."];
        errores = true;
      }
      if (this.modelValue.id_item === "") {
        this.errores.id_item = ["Debe seleccionar un ítem."];
        errores = true;
      }
      if (
        this.modelValue.detalle != null &&
        this.modelValue.detalle.length > 300
      ) {
        this.errores.detalle = [
          "El detalle no debe ser mayor a 300 caracteres.",
        ];
        swal(
          "El detalle no debe ser mayor a 300 caracteres.",
          "Mensaje",
          "warning"
        );
        return;
      }
      if (!errores) this.$emit("input", this.modelValue);
      else swal("Tiene validaciones que corregir.", "Mensaje", "warning");
    },
    buscarItems: function () {
      this.$modal.show("items");
    },
    seleccionarItem: function (item) {
      this.selectedItem = item;
      this.modelValue.id_item = item.codigo;
      this.modelValue.nombre_item = item.nombre;
      this.modelValue.valor_subsidio = item.valor_subsidio;
      this.modelValue.precio_sin_subsidio = item.precio_sin_subsidio;
      this.modelValue.iva_incluido_precio = item.iva_incluido_precio === "S";
      if (this.tipoComprobante === "99") {
        if (!this.modelValue.iva_incluido_precio)
          this.modelValue.precio = round(
            parseFloat(item.precio_subsidiado) *
            (1 + parseFloat(item.tarifa_iva.porcentaje) / 100)
          );
        else this.modelValue.precio = parseFloat(item.precio_subsidiado);
        this.modelValue.id_iva = "6";
        this.modelValue.id_ice = null;
        this.modelValue.irbpnr = false;
        this.modelValue.porcentaje_iva = 0;
      } else {
        let porcentaje = parseFloat(item.tarifa_iva.porcentaje);
        if (isNaN(porcentaje)) porcentaje = 0;
        if (porcentaje > 0 && (this.modelValue.iva_incluido_precio || (this.modelValue.iva_incluido_precio && !this.iva_incluido_exp && this.factura_exterior))) {
          let precio = parseFloat(item.precio_subsidiado);
          if (isNaN(precio)) precio = 0;
          this.modelValue.precio = round(precio / (1 + porcentaje / 100));
        } else {
          this.modelValue.precio = item.precio_subsidiado;
        }
        if (this.factura_exterior)
          this.modelValue.id_iva = '0';
        else 
          this.modelValue.id_iva = item.id_tarifa_iva;
        this.modelValue.id_ice = item.id_tarifa_ice;
        if (this.factura_exterior)
          this.modelValue.porcentaje_iva = 0;
        else 
          this.modelValue.porcentaje_iva = item.tarifa_iva.porcentaje;
        if (item.tarifa_ice !== null) {
          this.modelValue.porcentaje_ice = item.tarifa_ice.porcentaje;
          this.modelValue.tarifa_especifica_ice =
            item.tarifa_ice.tarifa_especifica;
          this.modelValue.numero_unidades_ice = item.tarifa_ice.numero_unidades;
          this.modelValue.porcentaje_ed_valorem =
            item.tarifa_ice.porcentaje_ed_valorem;
          this.modelValue.cantidad_ice = item.cantidad_ice;
        }
        this.modelValue.precio_produccion = item.precio_produccion;
        this.modelValue.cantidad_irbpnr = item.cantidad_irbpnr;
        if (this.modelValue.cantidad_irbpnr === null)
          this.modelValue.cantidad_irbpnr = 1;
        this.modelValue.irbpnr = item.irbpnr === "S";
      }
      this.modelValue.coste = item.costo;
      this.totalDigitado = this.total;
      this.$modal.hide("items");
    },
    calcularDescuentoTotal: function () {
      let descuentoTotal =
        this.total_inicial * (this.modelValue.porcentaje_descuento / 100);
      if (descuentoTotal <= this.total_inicial) {
        if (isNaN(descuentoTotal)) descuentoTotal = 0;
      } else {
        this.modelValue.porcentaje_descuento = 0;
        descuentoTotal = 0;
      }
      this.modelValue.total_descuento = round(descuentoTotal);
      this.totalDigitado = this.total;
    },
    calcularPorcentajeDescuento: function () {
      let porcentajeDescuento =
        (parseFloat(this.modelValue.total_descuento) / this.total_inicial) *
        100;
      if (porcentajeDescuento <= 100) {
        if (isNaN(porcentajeDescuento)) porcentajeDescuento = 0;
      } else {
        this.modelValue.total_descuento = 0;
        porcentajeDescuento = 0;
      }
      this.modelValue.porcentaje_descuento = round(porcentajeDescuento);
      this.totalDigitado = this.total;
    },
    calcularImpuestosTotales: function () {
      let totalImpuestos =
        parseFloat(this.iva) + parseFloat(this.ice) + parseFloat(this.irbpnr);
      this.modelValue.total_impuestos = round(totalImpuestos);
    },
  },
  watch: {
    "modelValue.iva": function () {
      this.calcularImpuestosTotales();
    },
    "modelValue.ice": function () {
      this.calcularImpuestosTotales();
    },
    "modelValue.total_irbpnr": function () {
      this.calcularImpuestosTotales();
    },
  },
  mounted: function () {
    if (this.modelValue.id_item != null && this.modelValue.id_item != '') {
      this.selectedItem = {
        codigo: this.modelValue.id_item,
        descripcion_item: this.modelValue.nombre_item
      };
    }
    this.calcularPorcentajeDescuento();
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemComprobante.vue